document.addEventListener('wheel', function(event){
  if(document.activeElement.type === 'number'){
    document.activeElement.blur();
  }
});
